// A-Ljus favourites: heart toggle on product cards, saved in this browser (localStorage)
if (!customElements.get('aljus-wishlist-button')) {
  const STORAGE_KEY = 'aljus-wishlist';

  const readList = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  };

  const writeList = (list) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // storage blocked (private mode etc.) - the heart still toggles for this page view
    }
    document.dispatchEvent(new CustomEvent('aljus:wishlist-change', { detail: { list } }));
  };

  customElements.define(
    'aljus-wishlist-button',
    class AljusWishlistButton extends HTMLElement {
      connectedCallback() {
        this.handle = this.dataset.handle;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggle.bind(this));
        this.onChange = () => this.render();
        document.addEventListener('aljus:wishlist-change', this.onChange);
        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('aljus:wishlist-change', this.onChange);
      }

      toggle(event) {
        event.preventDefault();
        const list = readList();
        const index = list.indexOf(this.handle);
        if (index === -1) {
          list.push(this.handle);
        } else {
          list.splice(index, 1);
        }
        writeList(list);
      }

      render() {
        const active = readList().includes(this.handle);
        this.classList.toggle('is-active', active);
        this.button.setAttribute('aria-pressed', active);
      }
    }
  );
}
